import { HttpResourceRef } from '@angular/common/http';
import { AfterContentInit, ChangeDetectorRef, DestroyRef, Directive, effect, ElementRef, inject, input, Renderer2, signal } from '@angular/core';
import { handleValidationErrors } from '../helpers/error-helpers';
import { ProblemDetailsModel } from '../models/problem-details';
//import { Tooltip } from 'bootstrap';
declare var bootstrap: any;

@Directive({
  selector: '[appProcessing]',
})


export class ProcessingDirective implements AfterContentInit {


  appProcessingClass = input('');
  appProcessing = input<boolean | HttpResourceRef<unknown> | null>(false);

  appProcessingChanges = effect(() => {
    const state = this.getProcessingState(this.appProcessing());
    this.toggleIndicators(state.processing, state.error, state.errorMessage);
  });



  cd = inject(ChangeDetectorRef);

  constructor(private host: ElementRef<HTMLElement>, private renderer: Renderer2, private destroyRef: DestroyRef) {
    destroyRef.onDestroy(() => {
      this.destroyTooltip();
    });
    //renderer.setStyle(host.nativeElement, 'display', 'inline-flex');
    renderer.setStyle(host.nativeElement, 'align-items', 'center');


  }

  spinner?: HTMLElement;
  errorIcon?: HTMLElement;
  ngAfterContentInit(): void {

    const parser = new DOMParser();
    const doc = parser.parseFromString(`
      <span class="visually-hidden spinner spinner-border spinner-border-sm ${this.appProcessingClass()}  ms-2"></span>
      `, 'text/html');
    this.spinner = doc.body.firstElementChild as HTMLElement;
    this.renderer.appendChild(this.host.nativeElement, this.spinner);

    const errorDoc = parser.parseFromString(`
      <i class="visually-hidden fas fa-exclamation-circle text-danger ms-2" aria-hidden="true" title="Error"></i>
      `, 'text/html');
    this.errorIcon = errorDoc.body.firstElementChild as HTMLElement;
    this.renderer.appendChild(this.host.nativeElement, this.errorIcon);


  }

  disabled = true;


  private toggleIndicators(processing: boolean, error: boolean, errorMessage: string | null) {
    if (processing) {
      this.disabled = this.host.nativeElement.hasAttribute('disabled');

      this.spinner && this.renderer.removeClass(this.spinner, 'visually-hidden');
      this.errorIcon && this.renderer.addClass(this.errorIcon, 'visually-hidden');
      if (this.errorIcon) {
        this.renderer.removeAttribute(this.errorIcon, 'title');
      }
      this.renderer.setAttribute(this.host.nativeElement, 'disabled', 'true');
    }
    else {
      this.spinner && this.renderer.addClass(this.spinner, 'visually-hidden');
      if (error) {
        this.errorIcon && this.renderer.removeClass(this.errorIcon, 'visually-hidden');
        if (this.errorIcon) {
          this.renderer.setAttribute(this.errorIcon, 'title', errorMessage ?? 'Error');
          this.renderer.setAttribute(this.errorIcon, 'data-bs-toggle', 'tooltip');
          this.renderer.setAttribute(this.errorIcon, 'data-bs-placement', 'top');
          this.renderer.setAttribute(this.errorIcon, 'data-bs-title', errorMessage ?? 'Error');
          console.log("add tooltip");
          this.buildTooltip(this.errorIcon, errorMessage ?? 'Error');
        }
      } else {
        this.errorIcon && this.renderer.addClass(this.errorIcon, 'visually-hidden');
        this.destroyTooltip();
        if (this.errorIcon) {
          this.renderer.removeAttribute(this.errorIcon, 'title');
        }
      }

      if (!this.disabled)
        this.renderer.removeAttribute(this.host.nativeElement, 'disabled');
    }
    this.cd.markForCheck();
  }

  private buildTooltip(element: HTMLElement, title: string): void {

    // Destroy any old instance before creating a new one
    this.destroyTooltip();


    // Set Bootstrap data attributes programmatically
    element.setAttribute('data-bs-toggle', 'tooltip');
    element.setAttribute('data-bs-placement', 'top');
    element.setAttribute('title', title);

    // Initialize the vanilla Bootstrap Tooltip
    this.tooltipInstance = new bootstrap.Tooltip(element);
  }
  tooltipInstance: any;
  private destroyTooltip(): void {
    if (this.tooltipInstance) {
      this.tooltipInstance.dispose();
      this.tooltipInstance = null;
    }
  }

  private getProcessingState(value: boolean | HttpResourceRef<unknown> | null): { processing: boolean; error: boolean; errorMessage: string | null } {
    if (typeof value === 'boolean') {
      return { processing: value, error: false, errorMessage: null };
    }

    if (!value) {
      return { processing: false, error: false, errorMessage: null };
    }

    const status = value.status();
    const resourceError = value.error();
    const hasError = resourceError != null || status === 'error';
    return {
      processing: (status === 'loading' || status === 'reloading') && !hasError,
      error: hasError,
      errorMessage: hasError ? this.getResourceErrorMessage(resourceError) ?? 'Error' : null,
    };
  }

  private getResourceErrorMessage(error: unknown): string | null {
    if (!error) {
      return null;
    }

    const problems = signal<ProblemDetailsModel | null>(null);

    const validationErrors = handleValidationErrors(error, problems);
    return validationErrors?.detail ?? validationErrors?.title ?? 'Error';
    // if (typeof error === 'string') {
    //   return error;
    // }

    // if (error instanceof Error && error.message.trim()) {
    //   return error.message;
    // }

    // if (typeof error === 'object') {
    //   const errObj = error as { message?: unknown; error?: unknown; detail?: unknown };
    //   if (typeof errObj.message === 'string' && errObj.message.trim()) {
    //     return errObj.message;
    //   }

    //   if (typeof errObj.detail === 'string' && errObj.detail.trim()) {
    //     return errObj.detail;
    //   }

    //   if (typeof errObj.error === 'string' && errObj.error.trim()) {
    //     return errObj.error;
    //   }

    //   if (errObj.error && typeof errObj.error === 'object') {
    //     const nested = errObj.error as { message?: unknown; detail?: unknown };
    //     if (typeof nested.message === 'string' && nested.message.trim()) {
    //       return nested.message;
    //     }
    //     if (typeof nested.detail === 'string' && nested.detail.trim()) {
    //       return nested.detail;
    //     }
    //   }
    // }

    //   return 'Error';
  }

}
